import { siteInfo } from '@/mocks/siteInfo';

export default function LatestAddress() {
  return (
    <section id="latest-address" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-link text-sm"></i>
            官方入口
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            禁漫天堂 JMComic 最新访问地址
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm">
            以下为当前可用的官方入口地址，建议收藏本页以获取最新更新
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
          <div className="flex flex-col sm:flex-row items-center gap-4 p-5 bg-primary-50 rounded-xl border border-primary-200/50 mb-6">
            <div className="w-12 h-12 flex items-center justify-center bg-primary-500 rounded-xl flex-shrink-0">
              <i className="ri-star-fill text-background-50 text-xl"></i>
            </div>
            <div className="flex-1 text-center sm:text-left">
              <div className="text-xs text-primary-600 font-medium mb-1">主站推荐</div>
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-700">{siteInfo.latestAddress}</div>
            </div>
            <a
              href={`https://${siteInfo.latestAddress}`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex-shrink-0"
            >
              <i className="ri-arrow-right-line mr-1.5"></i>立即访问
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {siteInfo.mirrorAddresses.map((addr, index) => (
              <div
                key={addr}
                className="flex items-center justify-between p-4 rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-300/50 transition-all duration-200"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 text-xs font-bold">
                    {index + 1}
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{addr}</span>
                </div>
                <a
                  href={`https://${addr}`}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>
            ))}
          </div>

          <div className="mt-6 p-4 rounded-xl bg-secondary-50 border border-secondary-200/50 flex items-start gap-3">
            <i className="ri-information-line text-secondary-500 text-lg mt-0.5 flex-shrink-0"></i>
            <p className="text-xs text-secondary-700 leading-relaxed">
              提示：如遇主站无法访问，请尝试使用以上镜像站地址。所有镜像站数据与主站完全同步，登录信息和阅读记录均可通用。建议将本页面加入书签，以便随时获取最新可用地址。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}